// @flow
import { compose } from "redux";
import { lifecycle } from "recompose";
import { connect } from "react-redux";
import { setNavigationColour } from "../../pages/MarketingLayout/Navigation/ducks";

const mapStateToProps = (state) => ({
  navigationColour: state.navigation.colour,
});

const mapDispatchToProps = (dispatch, props) => ({
  setNavigationColour: () => dispatch(setNavigationColour(props.colour)),
  clearNavigationColour: () => dispatch(setNavigationColour()),
});

const withNavColour = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  lifecycle({
    componentWillMount() {
      if (this.props.colour !== this.props.navigationColour) {
        this.props.setNavigationColour();
      }
    },
    componentDidUpdate() {
      if (this.props.colour !== this.props.navigationColour) {
        this.props.setNavigationColour();
      }
    },
    componentWillUnmount() {
      this.props.clearNavigationColour();
    },
  }),
);

export default withNavColour;
